import WebFont from 'webfontloader'

const options = {"google":{"families":["Raleway:100,200,300,400,500,600,700,800,900"]},"typekit":{"id":"rga5kdw"}}

WebFont.load(options)
